import React from 'react';
import { ImageBox } from '@eduvision/toolkit';
import image from '../images/BF_Logo.png';

const BildungsfreaksIcon = (props) => <ImageBox src={image} width="20px" {...props} />;

export default BildungsfreaksIcon;
